import * as yup from 'yup'
export const PHONE_RE = /^\s*(?:\+?(\d{1,3}))?[-. (]*([2-9]\d{2})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
export const ZIPCODE_RE = /^\d{5}(-\d{4})?$/

export const genRequestFormValidationSchema = () =>
  yup.object().shape({
    relationshipType: yup.string().required('Relationship is required'),
    accountType: yup.string().when('relationshipType', { is: 'Current or former member/applicant for SAFE products or services', then: yup.string().required('Account type is required') }),
    requestType: yup.string().required('Request type is required'),
    onBehalf: yup.string().required('Please select Yes or No')
  })

export const genAgentFormValidationSchema = () =>
  yup.object().shape({
    deliveryMethod: yup.string().required('Delivery method is required'),
    firstName: yup.string().required('First name is required'),
    middleName: yup.string(),
    lastName: yup.string().required('Last name is required'),
    suffix: yup.string(),
    email: yup
      .string()
      .email('Email is invalid')
      .when('deliveryMethod', { is: 'Email', then: (d: any) => d.required('Email is required') }),
    phone: yup.string().required('Phone number is required').matches(PHONE_RE, 'Invalid phone number'),
    dob: yup.date().typeError('Invalid Date').required('Date of birth is required').max(new Date()),
    addressLine1: yup.string().required('Mailing address is required'),
    addressLine2: yup.string(),
    city: yup.string().required('City is required'),
    state: yup.string().required('State is required'),
    zip: yup.string().required('ZIP code is required').matches(ZIPCODE_RE, 'Invalid zip code').min(5)
  })

export const genConsumerValidationSchema = (onBehalf: 'Yes' | 'No' | '') =>
  yup.object().shape({
    deliveryMethod: onBehalf === 'No' ? yup.string().required('Delivery method is required') : yup.string(),
    firstName: yup.string().required('First name is required'),
    middleName: yup.string(),
    lastName: yup.string().required('Last name is required'),
    suffix: yup.string(),
    email: yup
      .string()
      .email('Email is invalid')
      .when('deliveryMethod', { is: 'Email', then: (d: any) => d.required('Email is required') }),
    phone: yup.string().required('Phone number is required').matches(PHONE_RE, 'Invalid phone number'),
    accountNumber: yup.string(),
    dob: yup.date().typeError('Invalid Date').required('Date of birth is required'),
    addressLine1: yup.string().required('Mailing address is required'),
    addressLine2: yup.string(),
    city: yup.string().required('City is required'),
    state: yup.string().required('State is required'),
    zip: yup.string().required('ZIP code is required').matches(ZIPCODE_RE, 'Invalid zip code').min(5)
  })
